module.exports = {"610924100":"城关镇","610924101":"蒿坪镇","610924102":"汉王镇","610924103":"焕古镇","610924104":"向阳镇","610924105":"洞河镇","610924106":"洄水镇","610924108":"双桥镇","610924109":"高桥镇","610924110":"红椿镇","610924111":"高滩镇","610924112":"毛坝镇","610924113":"瓦庙镇","610924114":"麻柳镇","610924115":"双安镇","610924116":"东木镇","610924117":"界岭镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610924.json
// module id = 2877
// module chunks = 0